import { render, staticRenderFns } from "./StudentPlacementForm.vue?vue&type=template&id=7d0ac4fc&"
import script from "./StudentPlacementForm.vue?vue&type=script&lang=js&"
export * from "./StudentPlacementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports